import { v4 as uuidv4 } from 'uuid';

export const createSection = (
  type: 'content' | 'table' | 'figure',
  isDisabled = false,
  sectionType?: string
) => {
  const uniqueId = uuidv4();
  return {
    id: uniqueId,
    type,
    data: sectionType
      ? {
          type: 'doc',
          content: [
            {
              type: 'heading',
              attrs: {
                textAlign: null,
                level: 3
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  text: sectionType === 'discussion' ? 'Discussion' : 'Mitigations'
                }
              ]
            }
          ]
        }
      : null,
    isDisabled
  };
};

export const riskLevels = {
  low: { value: 'low', label: 'Low' },
  medium: { value: 'medium', label: 'Medium' },
  high: { value: 'high', label: 'High' },
  low_to_medium: { value: 'low_to_medium', label: 'Low to Medium' },
  medium_to_high: { value: 'medium_to_high', label: 'Medium to High' }
};

export const getDefaultRiskDriverContent = () => [
  {
    id: uuidv4(),
    type: 'content',
    data: {
      type: 'doc',
      content: [
        {
          type: 'heading',
          attrs: {
            textAlign: null,
            level: 3
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'bold'
                }
              ],
              text: 'Discussion'
            }
          ]
        }
      ]
    },
    isDisabled: true
  },
  {
    id: uuidv4(),
    type: 'content',
    data: {
      type: 'doc',
      content: []
    }
  },
  {
    id: uuidv4(),
    type: 'content',
    data: {
      type: 'doc',
      content: [
        {
          type: 'heading',
          attrs: {
            textAlign: null,
            level: 3
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'bold'
                }
              ],
              text: 'Mitigations'
            }
          ]
        }
      ]
    },
    isDisabled: true
  },
  {
    id: uuidv4(),
    type: 'content',
    data: {
      type: 'doc',
      content: []
    }
  }
];

export const activeTabMap = {
  additionality: { name: 'non-additionality', value: 'additionality' },
  overCrediting: { name: 'over-crediting', value: 'overCrediting' },
  permanence: { name: 'permanence', value: 'permanence' },
  overLappingClaims: { name: 'overlapping claims', value: 'overLappingClaims' }
};

export enum UpdateType {
  module_added = 'module_added',
  methodology_added = 'methodology_added'
}
